var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.733,
    height: 15.523,
    viewBox: "0 0 16.733 15.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-briefcase",
    "data-name": "Icon ionic-ios-briefcase",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M4.585,24.222H17.9a1.209,1.209,0,0,0,1.21-1.21V15.75H3.375v7.261A1.209,1.209,0,0,0,4.585,24.222Z",
    transform: "translate(-3.375 -9.699)",
    fill: "none",
    stroke: "#30346B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M17.9,6.92h-.3v-.3a.3.3,0,0,0-.3-.3h-1.21a.3.3,0,0,0-.3.3v.3H14.721V5.71a1.214,1.214,0,0,0-1.21-1.21H8.972a1.214,1.214,0,0,0-1.21,1.21V6.92H6.7v-.3a.3.3,0,0,0-.3-.3H5.19a.3.3,0,0,0-.3.3v.3h-.3a1.209,1.209,0,0,0-1.21,1.21V9.643H19.108V8.131A1.209,1.209,0,0,0,17.9,6.92Zm-4.236,0H8.821V5.862a.3.3,0,0,1,.3-.3h4.236a.3.3,0,0,1,.3.3Z",
    transform: "translate(-3.375 -4.5)",
    fill: "none",
    stroke: "#30346B",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.679e152c8aa9f16e9a200471ee82b2a6.svg";
export { ForwardRef as ReactComponent };